import { fmtMoney, yearLabel } from '../lib/format';
import type { Totals4 } from '../lib/totals';

type Props = {
  baseYear: number;
  operatingNet: Totals4;
  totalProjectsNet: Totals4;
  financialNet: Totals4;
  grandNet: Totals4;
  hasProjects: boolean;
  hasFinancial: boolean;
};

export function GrandTotalPanel({
  baseYear,
  operatingNet,
  totalProjectsNet,
  financialNet,
  grandNet,
  hasProjects,
  hasFinancial,
}: Props) {
  const valueClass = (n: number) => `right ${n >= 0 ? 'text-ccaanz-blue' : 'text-ccaanz-black'}`;

  return (
    <section className="panel mb-4">
      <div className="panel-section">
        <div className="panel-section-title">Grand Total — Net Result</div>
        <div className="panel-section-sub">
          Operating + discrete activities + non-operating, projected at the global CPI defaults.
        </div>

        <table className="grand-total-table">
          <thead>
            <tr>
              <th></th>
              <th className="right">{yearLabel(baseYear, 0)}</th>
              <th className="right">{yearLabel(baseYear, 1)}</th>
              <th className="right">{yearLabel(baseYear, 2)}</th>
              <th className="right">{yearLabel(baseYear, 3)}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Net Operating</td>
              <td className={valueClass(operatingNet.current)}>{fmtMoney(operatingNet.current)}</td>
              <td className={valueClass(operatingNet.y1)}>{fmtMoney(operatingNet.y1)}</td>
              <td className={valueClass(operatingNet.y2)}>{fmtMoney(operatingNet.y2)}</td>
              <td className={valueClass(operatingNet.y3)}>{fmtMoney(operatingNet.y3)}</td>
            </tr>
            {hasProjects && (
              <tr>
                <td>Net Discrete</td>
                <td className={valueClass(totalProjectsNet.current)}>
                  {fmtMoney(totalProjectsNet.current)}
                </td>
                <td className={valueClass(totalProjectsNet.y1)}>{fmtMoney(totalProjectsNet.y1)}</td>
                <td className={valueClass(totalProjectsNet.y2)}>{fmtMoney(totalProjectsNet.y2)}</td>
                <td className={valueClass(totalProjectsNet.y3)}>{fmtMoney(totalProjectsNet.y3)}</td>
              </tr>
            )}
            {hasFinancial && (
              <tr>
                <td>Net Non-Operating</td>
                <td className={valueClass(financialNet.current)}>
                  {fmtMoney(financialNet.current)}
                </td>
                <td className={valueClass(financialNet.y1)}>{fmtMoney(financialNet.y1)}</td>
                <td className={valueClass(financialNet.y2)}>{fmtMoney(financialNet.y2)}</td>
                <td className={valueClass(financialNet.y3)}>{fmtMoney(financialNet.y3)}</td>
              </tr>
            )}
            <tr className="grand-total-row">
              <td>Grand Total Net</td>
              <td className={valueClass(grandNet.current)}>{fmtMoney(grandNet.current)}</td>
              <td className={valueClass(grandNet.y1)}>{fmtMoney(grandNet.y1)}</td>
              <td className={valueClass(grandNet.y2)}>{fmtMoney(grandNet.y2)}</td>
              <td className={valueClass(grandNet.y3)}>{fmtMoney(grandNet.y3)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
